// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1pP-i","colCheckbox":"styles_colCheckbox__KigXg"};